import { getLogger } from '../diagnostics/logger';
import { applyMiddleware, compose, createStore, Middleware, Store } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import sagaMiddlewareFactory from 'redux-saga';
import { AppState } from '../models/state/appState';
import rootReducer from '../reducers';
import { initSagas } from './initSagas';

const log = getLogger('simmanagement.store.configureStore');

const loggerMiddleware: Middleware<any, any, any> = (api: any) => (next: any) => (action: any) => {
  return next(action);
};

const sagaMiddleware = sagaMiddlewareFactory();

export default function configureStore(initialState: AppState): Store<AppState, any> {
  const composeEnhancers =
    typeof window === 'object' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
      : compose;

  // The invariant middleware deep-copies state on every dispatch, so it must not run in live builds.
  const middleware: Middleware<any, any, any>[] = [loggerMiddleware, sagaMiddleware];
  if (typeof env === 'undefined' || env !== 'live') {
    middleware.push(reduxImmutableStateInvariant() as Middleware<any, any, any>);
  }

  const enhancer = composeEnhancers(
    applyMiddleware(...middleware),
    // other store enhancers if any
  );

  const store = createStore(rootReducer, initialState, enhancer);

  initSagas(sagaMiddleware);
  return store;
}
